import styled from 'styled-components';

/**
 * Velo de navegación: cubre la ventana mientras se carga la pantalla
 * siguiente.
 *
 * ── Por qué NO sustituye al contenido (feedback tablet 2026-08-15) ─────────
 *
 * La primera versión pintaba el `<Loader/>` EN LUGAR del `<Outlet/>`. Dentro
 * del asistente de actuación eso se veía mal: al saltar de pestaña
 * desaparecían de golpe la cabecera de la OT, la barra de pestañas y el
 * formulario, la página pasaba de miles de píxeles de alto a los 5rem del
 * cuadrado, y como el documento scrollea en la ventana el navegador no tenía
 * dónde sostener la posición — te subía al principio. El operario perdía de
 * vista la pestaña a la que iba.
 *
 * Superponiendo no se desmonta nada: la altura no cambia, el scroll se queda
 * donde estaba, y la barra de pestañas se sigue viendo por detrás.
 *
 * Va en un portal a `document.body` (mismo recurso que `DropDownList`) para
 * que ningún ancestro con `transform`/`filter` cree un contexto de apilado que
 * lo atrape, y para no meter un nodo extra en el flex del layout.
 *
 * Cubrir la ventana además **bloquea el toque**, que era la otra mitad del
 * problema original: sin nada que pulsar no hay doble pulsación.
 */
export const NavigationVeil = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${({ theme }) => theme.zIndex.popover};

  display: flex;
  align-items: center;
  justify-content: center;

  /* Translúcido a propósito: se ve lo que hay debajo (la barra de pestañas,
     el formulario) para no perder el sitio. */
  background-color: rgba(245, 245, 255, 0.7);

  /* El Loader canónico trae "margin: auto" para autocentrarse cuando se usa
     suelto. Dentro de un flex ese auto-margin absorbe todo el espacio libre y
     anula el centrado, dejándolo pegado abajo. Mismo apaño que SplashScreen. */
  & > [role='progressbar'] {
    margin: 0;
  }
`;
